import { PQR_RECEPTION_CHANNEL_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const usePqrReceptionChannelListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_RECEPTION_CHANNEL_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
